import React, { useState } from "react";
import LectureForm from "../Components/LectureForm";

const LectureManagementPage = () => {
  const [courseLectures, setCourseLectures] = useState([]);

  return (
    <div className="space-y-4">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h2 className="text-lg font-semibold text-slate-200">
          Upload course lectures
        </h2>
        <p className="text-xs text-slate-500">
          Select a course and add lecture videos.
        </p>
      </div>
      <LectureForm
        courseLectures={courseLectures}
        setCourseLectures={setCourseLectures}
      />
    </div>
  );
};

export default LectureManagementPage;

